<template>
  <div>
    <DxLoadPanel
      :visible="loadingVisible"
      :show-indicator="showIndicator"
      :show-pane="showPane"
      :shading="shading"
      :close-on-outside-click="closeOnOutsideClick"
      shading-color="rgba(0,0,0,0.4)"
    />
    <section class="content-header custom-header">
      <h1>{{LangSelected.Interno.InvitacionProveedores.Titulo}}</h1>
    </section>
    <section class="content container-fluid">
      <div class="box" style="margin-bottom: 5px;">
        <div class="form-horizontal">
          <div class="box-body">
            <div class="row">
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <span class="col-sm-4 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Estatus}}</span>
                <div class="col-sm-8">
                  <div class="value">
                    <DxSelectBox
                      class="selector_action"
                      :data-source="JSONEstatus"
                      value-expr="Id_EstatusWorkflow"
                      display-expr="Estatus"
                      :value="selEstatus"
                      @value-changed="depEstatus($event)"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group col-sm-12 col-md-6 col-xs-12 col-lg-6" style="margin-bottom: 0px;">
                <div class="col-sm-12">
                  <div class="value">
                    <DxCheckBox
                      :value="selVer"
                      :text="LangSelected.Interno.InvitacionProveedores.VerSoloBtnText"
                      class="checkboxTextStile"
                      style="vertical-align:top;"
                      @value-changed="depVer($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" style="border-top: none;">
        <div class="form-horizontal">
          <div class="box-body">
            <div class="col-sm-12" style="text-align:right; margin-bottom:10px; padding-right:0px;">
              <b-button size="sm" variant="primary" class="btnSimple" @click="AgregarInvitacion()">{{LangSelected.Interno.InvitacionProveedores.BtnInvitar}}</b-button>
            </div>
            <form>
              <DxDataGrid 
              id="gridJSONInvitaciones"
              :data-source="JSONtbInvitaciones"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              :column-auto-width="true"
              :show-borders="true"
              key-expr="Id_ProveedorUsuarioInvitacion"
              >
                <DxColumnChooser :enabled="false"/>
                <DxColumnFixing :enabled="true"/>
                <DxFilterRow :visible="true"/>
                <DxPaging :page-size="13"/>
                <DxEditing
                  :allow-updating="true"
                  mode="cell"
                />
                <DxPager
                  :show-page-size-selector="true"
                  :allowed-page-sizes="[]"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.FechaInvitacion"
                  data-field="FechaInvitacion"
                  alignment="center"
                  width="10%"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.Estatus"
                  data-field="Estatus"
                  alignment="center"
                  width="10%"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.FechaEstatus"
                  data-field="FechaUltimoEstatus"
                  alignment="center"
                  width="12%"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.Proveedor"
                  data-field="Proveedor"
                  alignment="left"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.Contacto"
                  data-field="Contacto"
                  alignment="left"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.CorreoContacto"
                  data-field="CorreoContacto"
                  alignment="left"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.InvitadoPor"
                  data-field="InvitadoPor"
                  alignment="left"
                  data-type="string"
                  :allow-editing="false"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.ColEnviar"
                  data-field="Enviar"
                  alignment="center"
                  width="5.5%"
                  :allow-editing="false"
                  :allow-filtering="false"
                  cell-template="cellEnviar"
                />
                <DxColumn
                  :caption="LangSelected.Interno.InvitacionProveedores.ColCancelar"
                  data-field="Cancelar"
                  alignment="center"
                  width="5.5%"
                  :allow-editing="false"
                  :allow-filtering="false"
                  cell-template="cellCancelar"
                />
                <template #cellCancelar={data}>
                  <i class='fa fa-trash' v-if="data.data.btnBorrarInvitacion==1" style="color:rgb(144, 147, 151); cursor:pointer;" @click="CancelarInvitacion(data)"></i>
                </template>
                <template #cellEnviar={data}>
                  <i class='fa fa-envelope' v-if="data.data.btnReenviarInvitacion==1" style="color:rgb(144, 147, 151); cursor:pointer;" @click="EnviarInvitacion(data)"></i>
                </template>
              </DxDataGrid>
            </form>
          </div>
        </div>
      </div>
    </section>
    <b-modal id="modal-1" ref="modal-1" :title="LangSelected.Interno.InvitacionProveedores.ModalTitulo" size="35%" button-size="sm" :no-close-on-esc="true" :no-close-on-backdrop="true" style="width:90%;">
      <div class="modal-body" style="padding-top: 0px; padding-bottom: 0px; padding:0px;">
        <div class="box box-default box-solid" style="margin-bottom: 4px;margin-top: 4px;">
          <div class="box-body">
            <!--<div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Proyecto}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxSelectBox
                      class="selector_action"
                      :data-source="JSONProyectos"
                      value-expr="Id_Proyecto"
                      display-expr="Clave_Proyecto"
                      :value="selProyecto"
                      @value-changed="depProyectos($event)"
                    />
                  </div>
                </div>
              </div>
            </div>-->
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 10px;">
                <div class="col-sm-6">
                  <span class="col-sm-12 span-label" style="padding-top: 0px;text-align: center;border-bottom: solid thin #d2d6de;margin-top: 10px;font-size: .9em;font-weight: normal;">{{LangSelected.Interno.InvitacionProveedores.TipoProveedor}}</span>
                  <div class="dx-field">
                    <DxRadioGroup
                      :items="NuevoExistenteEntities"
                      value-expr="id"
                      display-expr="text"
                      layout="horizontal"
                      :value="NuevoExistente"
                      @valueChanged="changeNuevoExistente"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <span class="col-sm-12 span-label" v-show="NuevoExistente==0" style="padding-top: 0px;text-align: center;border-bottom: solid thin #d2d6de;margin-top: 10px;font-size: .9em;font-weight: normal;">{{LangSelected.Interno.InvitacionProveedores.TipoPersona}}</span>
                  <div class="dx-field">
                    <DxRadioGroup
                      v-show="NuevoExistente==0"
                      :items="MoralFisicaEntities"
                      value-expr="id"
                      display-expr="text"
                      layout="horizontal"
                      :value="MoralFisica"
                      @valueChanged="changeMoralFisica"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="NuevoExistente==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <div class="col-sm-12">
                  <div class="value">
                    <DxCheckBox
                      :value="selSubcontratos"
                      :text="LangSelected.Interno.InvitacionProveedores.SolicitarSubcontratos"
                      class="checkboxTextStile"
                      style="vertical-align:top;"
                      @value-changed="depSubcontratos($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="NuevoExistente==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Proyecto}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxSelectBox
                      :search-enabled="true"
                      :search-mode="searchModeOptionProyecto"
                      :search-expr="searchExprOptionProyecto"
                      :data-source="JSONProyecto"
                      value-expr="Id_Proyecto"
                      display-expr="Clave_Proyecto"
                      :value="selProyecto"
                      @value-changed="depProyecto($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="NuevoExistente==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Pais}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxSelectBox
                      :search-enabled="true"
                      :search-mode="searchModeOptionPais"
                      :search-expr="searchExprOptionPais"
                      :data-source="JSONPais"
                      value-expr="Id_Pais"
                      display-expr="Pais"
                      :value="selPais"
                      @value-changed="depPais($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="NuevoExistente==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.RazonSocial}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selRazonSocial"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.RazonSocialPH"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="NuevoExistente==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.NomCom}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selNombreComercial"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.NomComPH"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="NuevoExistente==0">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.DiasPlazo}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxNumberBox
                      v-model="selDiasPlazo"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.DiasPlazoHint"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--<div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">RFC</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selRFC"
                      placeholder="RFC"
                      :max-length="80"
                    />
                  </div>
                </div>
              </div>
            </div>-->
            <div class="row" v-show="NuevoExistente==1">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Proveedor}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxAutocomplete
                      :data-source="JSONProveedores"
                      v-model="NombreDescripcion"
                      :min-search-length="5"
                      :search-timeout="500"                            
                      :searchExpr="searchExprOption"
                      :searchMode="searchModeOption"
                      displayExpr="Id_Proveedor"
                      valueExpr="Proveedor"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.ProveedorBuscarPH"
                      @value-changed="onChange()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-12 span-label" style="padding-top: 0px;text-align: center;border-bottom: solid thin #d2d6de;margin-top: 10px;font-size: .9em;font-weight: normal;">{{LangSelected.Interno.InvitacionProveedores.SeccionContacto}}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Nombres}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selNombre"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.NombresPH"
                      :max-length="80"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Apellidos}}</span>
                <div class="col-sm-4">
                  <DxTextBox
                    v-model="selApellidoP"
                    :placeholder="LangSelected.Interno.InvitacionProveedores.ApPaternoPH"
                    :max-length="80"
                  />
                </div>
                <span class="col-sm-1 span-label" style="padding-top: 0px;">&nbsp;</span>
                <div class="col-sm-4">
                  <DxTextBox
                    v-model="selApellidoM"
                    :placeholder="LangSelected.Interno.InvitacionProveedores.ApMaternoPH"
                    :max-length="80"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Puesto}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selPuesto"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.PuestoPH"
                      :max-length="80"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.CorreoLabel}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selCorreoContacto"
                      :placeholder="LangSelected.Interno.InvitacionProveedores.CorreoPH"
                      :max-length="80"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-3 span-label" style="padding-top: 0px;">{{LangSelected.Interno.InvitacionProveedores.Telefono}}</span>
                <div class="col-sm-9">
                  <div class="value">
                    <DxTextBox
                      v-model="selTelefono"
                      :mask-rules="rules"
                      mask="(X00) 000-0000"
                      :max-length="80"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <span class="col-sm-12 span-label" style="padding-top: 0px;text-align: center;border-bottom: solid thin #d2d6de;margin-top: 10px;font-size: .9em;font-weight: normal;">{{LangSelected.Interno.InvitacionProveedores.ComentariosInvitacion}}</span>
              </div>
            </div>
            <div class="row" style="margin-top:5px">
              <div class="form-group col-sm-12 col-md-12 col-xs-12 col-lg-12" style="margin-bottom: 0px;">
                <div class="col-sm-12">
                  <div class="value">
                    <DxTextArea
                      :height="90"
                      :max-length="400"
                      v-model="selComentarios"
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer="{}">
        <b-button size="sm" variant="secondary" @click="cancel()">
          {{LangSelected.Interno.InvitacionProveedores.BtnCancelar}}
        </b-button>
        <b-button size="sm" variant="primary" @click="enviar()">
          {{LangSelected.Interno.InvitacionProveedores.BtnEnviarInvitacion}}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
// RUTA_SERVIDOR eliminada — migrada a apiClient
//const dataGridRef = 'dataGrid';

import { DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging, DxEditing} from 'devextreme-vue/data-grid';
import { DxCheckBox } from 'devextreme-vue/check-box';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
//import { DxAutocomplete } from 'devextreme-vue/autocomplete';
import DxSelectBox from 'devextreme-vue/select-box';
import DxTextBox from 'devextreme-vue/text-box';
import DxNumberBox from 'devextreme-vue/number-box';
//import DatePicker from 'vue2-datepicker';
// axios eliminado — migrado a apiClient
import apiClient from '@/services/apiClient';
import notify from 'devextreme/ui/notify';
//import func from 'vue-editor-bridge';
import DxTextArea from 'devextreme-vue/text-area';

import { confirm } from "devextreme/ui/dialog";

import { DxAutocomplete } from 'devextreme-vue/autocomplete';
import DxRadioGroup from 'devextreme-vue/radio-group';


/*function escapeURI(value,EncodeDecode="e"){
  value=value.toString();
  if(EncodeDecode=="e"){
    value=value.replace(/'/g,"''");
    return window.encodeURIComponent(value);
  }else if(EncodeDecode=="d"){
    value=value.replace("%40","@");
    return window.decodeURI(value);
  }else{
    return "";
  }
}*/


function isMail(mail){
  var isMail = false;
  if(mail.indexOf('.')>-1 && (mail.match(/@/g) || []).length==1){
    isMail = true;
  }else{
    isMail = false;
  }
  return isMail;
}

function BooleanToInt(val){
  return val = (val)?1:0;
}

/*function dateFormater(value){
  var newFecha;
  const meses = {
    0: 'ENE',
    1: 'FEB',
    2: 'MAR',
    3: 'ABR',
    4: 'MAY',
    5: 'JUN',
    6: 'JUL',
    7: 'AGO',
    8: 'SEP',
    9: 'OCT',
    10: 'NOV',
    11: 'DIC'
  }
  if(value.length == 9 && value){
    newFecha = value;
  }else{
    newFecha =(meses[value.getMonth()])?"'"+value.getDate()+"-"+meses[value.getMonth()]+"-"+value.getFullYear()+"'":null;
  }
  return newFecha;
}*/

export default {
  components:{
    DxLoadPanel,
  //DatePicker,
    DxAutocomplete,
    DxCheckBox,
    DxTextBox,
    DxSelectBox,
    DxTextArea,
    DxRadioGroup,
    DxNumberBox,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxPager, DxFilterRow, DxPaging, DxEditing
  },
  data(){
    return{
      LangSelected: JSON.parse(localStorage.getItem('languageInfo')),
      //* G E N E R A L     V A R I A B L E S *//
      IDPU: localStorage.getItem('IDPU'),
      IDUS: localStorage.getItem('IDUS'),
      RFCP: localStorage.getItem('RFCP'),
      AREu: localStorage.getItem('AREu'),
      USER: localStorage.getItem('mail'),
      USERSIGA: localStorage.getItem('IDUSiga'),
      multiple:true,//Configuración de DxFileUploader multiple
      loadingVisible: false,//Configuracion de loader
      showIndicator: true,
      shading: true,
      showPane: true,
      closeOnOutsideClick: false,
      showSecondBoxInfo:false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      //Id_Contrato:37,
      //Id_Proyecto:50,
      //Id_Contratista:-1,

      //* I N V I T A C I O N   V A R I A B L E S *//
      resetChange:0,

      JSONEstatus:[],
      selEstatus:null,

      selVer:true,

      JSONtbInvitaciones:[],

      //JSONProyectos:[],
      //selProyecto:null,
      JSONProveedores:[],
      selProveedor:null,
      selNombre:null,
      selApellidoP:null,
      selApellidoM:null,
      selCorreoContacto:null,
      selTelefono:null, rules: { 'X': /[02-9]/ },
      selComentarios:null,

      selSubcontratos:true,
      searchModeOptionProyecto: 'contains',
      searchExprOptionProyecto: 'Clave_Proyecto',
      JSONProyecto:[],
      selProyecto:null,

      searchModeOptionPais: 'contains',
      searchExprOptionPais: 'Pais',
      JSONPais:[],
      selPais:null,
      selPaisAltaProveedor:0,
      selPaisCambioCuenta:0,
      selRazonSocial:null,
      selNombreComercial:null,
      selDiasPlazo:30,
      selPuesto:null,

      searchModeOption: 'contains',
      searchExprOption: 'Proveedor',
      NombreDescripcion: '',
      NuevoExistenteEntities: [
        { id: 0, text: 'Nuevo' },
        { id: 1, text: 'Existente' }
      ],
      NuevoExistente: 0,
      MoralFisicaEntities: [
        { id: 1, text: 'Moral' },
        { id: 2, text: 'Física' }
      ],
      MoralFisica: 1
      //selRFC:""
    };
  },
  computed: {
    /*dataGrid: function() {
        return this.$refs[dataGridRef].instance;
    }*/
    editRowKey: {
      get() {
        return this.$store.state.editRowKey;
      },
      set(value) {
        this.setEditRowKey(value);
      }
    },
    changes: {
      get() {
        return this.$store.state.changes;
      },
      set(value) {
        this.setChanges(value);
      }
    }
  },
  //* INICIANDO CONSULTAS *//
  created:function(){
    var that = this;
    if(that.AREu){
      console.log(that.USER);
      that.loadingVisible = true;
      //console.log(RUTA_SERVIDOR + 'registroProv.aspx');
      apiClient.get('/api/Proveedores/Proveedores', { params: { Todos: 0, Autocomplete: 0, FormatoXML: false } })
      .then(function (response) {
        console.log(response);
        if(response.data[0].Estatus){
          that.JSONProveedores = [];
          that.selProveedor=0;
          notify(response.data[0].Mensaje, 'warning');
        }else{
          that.JSONProveedores = response.data;
          that.selProveedor=response.data[0].Selected;
          //notify(response.data.length+' contrato(s) encontrado(s).', 'success');
        }
        apiClient.get('/api/Proveedores/EstatusInvitaciones', { params: { Todos: -1, FormatoXML: false } })
        .then(function (response) {
          console.log(response);
          that.JSONEstatus = response.data;
          that.selEstatus = response.data[0].Selected;
          apiClient.post('/api/Proveedores/InvitacionesProveedores', { Id_EstatusWorkflow: response.data[0].Selected, Correo: that.USER, SoloMisInvitaciones: 1, FormatoXML: false })
          .then(function (response) {
            console.log(response);
            that.JSONtbInvitaciones = response.data || [];
            console.log(that.JSONtbInvitaciones);

            apiClient.get('/api/Proveedores/Paises-t', { params: { Todos: 0, FormatoXML: false } })
            .then(function (response) {
              console.log(response);
              that.JSONPais = response.data;
              that.selPais = "153";//response.data[0].Selected;
              
              // Inicializar los flags del país por defecto
              var paisDefecto = that.JSONPais.find(function(pais) {
                return pais.Id_Pais == "153";
              });
              if(paisDefecto){
                that.selPaisAltaProveedor = paisDefecto.AltaProveedor;
                that.selPaisCambioCuenta = paisDefecto.CambioCuenta;
              }
              
              console.log(that.selPais);
              console.log(that.JSONPais);

              apiClient.get('/api/General/getProyectos-t', { params: { Todos: 0, FormatoXML: false } })
              .then(function (respons) {
                console.log(respons);
                that.JSONProyecto = respons.data;
                that.selProyecto = respons.data[0].Seleccionar;
                that.loadingVisible = false;
              })
              .catch(function (error) {
                notify('Error al consultar los proyectos', 'error');
                console.log('Error: ' + error);
                that.loadingVisible = false;
              });
            })
            .catch(function (error) {
              notify('Error al consultar los paises', 'error');
              console.log('Error: ' + error);
              that.loadingVisible = false;
            });
          })
          .catch(function (error) {
            notify('Error al consultar las invitaciones', 'error');
            console.log('Error: ' + error);
            that.loadingVisible = false;
          });
          that.loadingVisible = false;
        })
        .catch(function (error) {
          notify('Error al consultar el estatus', 'error');
          console.log('Error: ' + error);
          that.loadingVisible = false;
        });
        that.loadingVisible = false;
      })
      .catch(function (error) {
        notify('Error al consultar los contratista', 'error');
        console.log('Error: ' + error);
        that.loadingVisible = false;
      });
      that.resetChange=0;
    }else{
      notify('Lo sentimos no tienes acceso a este apartado.', 'error');
      that.$router.push({name:'Home'});
    }
  },
  methods:{
    changeNuevoExistente(e) {
      this.NuevoExistente = e.value;
      console.log(this.NuevoExistente);
    },
    changeMoralFisica(e) {
      this.MoralFisica = e.value;
      console.log(this.MoralFisica);
    },
    depPais:function(e){
      var that = this;
      that.selPais = e.value;
      
      // Buscar el país seleccionado en el array para obtener los flags
      var paisSeleccionado = that.JSONPais.find(function(pais) {
        return pais.Id_Pais == e.value;
      });
      
      if(paisSeleccionado){
        that.selPaisAltaProveedor = paisSeleccionado.AltaProveedor;
        that.selPaisCambioCuenta = paisSeleccionado.CambioCuenta;
        
        // Validar los flags
        if(paisSeleccionado.AltaProveedor == 0){
          notify('El país seleccionado no cuenta con configuración de documentación requerida para alta de proveedor, favor de contactar al área de TI.', 'warning', 8000);
        }
        if(paisSeleccionado.CambioCuenta == 0){
          notify('El país seleccionado no cuenta con configuración de documentación requerida para cuenta bancaria, favor de contactar al área de cuentas por pagar.', 'warning', 8000);
        }
      }
    },
    depProyecto:function(e){
      this.selProyecto = e.value;
    },
    depEstatus:function(e){
      var that = this;
      if(that.resetChange==1){
        that.getInvitacionesProveedores(e.value, this.USER, BooleanToInt(this.selVer));
        this.selEstatus = e.value;
      }else{
        that.resetChange=1;
      }
    },
    depVer:function(e){
      var that = this;
      if(that.resetChange==1){
        that.getInvitacionesProveedores(that.selEstatus, this.USER, BooleanToInt(e.value));
        this.selVer = e.value;
      }else{
        that.resetChange=1;
      }
    },
    depSubcontratos:function(e){
      //var that = this;
      //if(that.resetChange==1){
        console.log(e.value);
        this.selSubcontratos = e.value;
      //}else{
        //that.resetChange=1;
      //}
    },
    /*depProyectos:function(e){
      var that = this;
      if(that.resetChange==1){
        that.getProveedor(e.value, 0, 1, 0, that.IDUS);
        this.selProyecto = e.value; 
      }else{
        that.resetChange=1;
      }
    },*/
    onChange:function(e) {
      var that = this;
      if(that.resetChange==1){
        console.log(e);
        console.log(this.NombreDescripcion);
        //console.log(this.ProveedorSelector);
        var comparation = this.NombreDescripcion;
        var result = this.JSONProveedores.filter(function (data) { return data.Proveedor == comparation; });   
        //console.log(result); 
        if(result[0]){
          this.selProveedor = result[0].Id_Proveedor;
        }
        console.log(this.selProveedor);
      }else{
        that.resetChange=1;
      }
    },
    CancelarInvitacion:function(datos){
      let result = confirm({
                            title:"Eliminar",
                            messageHtml:"<i>¿Deseas eliminar la invitación a "+datos.data.Contacto+" ("+datos.data.CorreoContacto+")?</i>",
                            buttons: [
                              {
                                text: "Confirmar",
                                onClick: (e) => {
                                    return { buttonText: e.component.option("text") }
                                }
                              },
                              {
                                text: "Cancelar",
                                onClick: (e) => {
                                    return { buttonText: e.component.option("text") }
                                }
                              }
                            ]
                          });
      result.then((dialogResult) => {
        if(dialogResult.buttonText=="Confirmar"){
          console.log('eliminando');
          this.getCancelar(datos.data.Id_ProveedorUsuarioInvitacion, datos.data.TipoInvitacion);
        }
      });
      //console.log(datos);
    },
    EnviarInvitacion:function(datos){
      var that= this;
      var endpoint = datos.data.TipoInvitacion=="Nuevo" ? 'enviarInvitacionNuevo' : 'enviarInvitacionExistente';
      apiClient.post('/api/Proveedores/' + endpoint, { Token: datos.data.Token, CorreoContacto: datos.data.CorreoContacto, CorreoCopia: that.USER, Contacto: datos.data.Contacto })
      .then(function (response) {
        if(response.data[0].Estatus == 'Ok'){
          notify('Invitacion enviada.', 'success');
        }else{
          notify(response.data[0].Mensaje, 'error');
        }
      }).catch(e => {
        notify('Error al enviar la invitación.', 'error');
        console.log(e);
      });
    },
    AgregarInvitacion:function(){
      var that = this;
      //that.getProyectos();
      //that.getProveedor();
      that.clearData();
      that.$refs['modal-1'].show();
    },
    clearData:function(){
      var that = this;
      console.log('limpiando');
      that.selProveedor=null;
      that.selPais="153";
      that.selRazonSocial=null;
      that.selNombreComercial=null;
      that.selDiasPlazo=30;
      that.selNombre=null;
      that.selApellidoP=null;
      that.selApellidoM=null;
      that.selPuesto=null;
      that.selCorreoContacto=null;
      that.selTelefono=null;
      that.selComentarios=null;
      that.NombreDescripcion=null;
    },
    cancel:function(){
      var that = this;
      that.clearData();
      that.$refs['modal-1'].hide();
    },
    enviar:function(){
      var that = this;
      that.loadingVisible = true;
      console.log(that.NuevoExistente);
      if(that.NuevoExistente==0){
        console.log('sp_prv_updInvitacionNuevoProveedorEnviar_XML');

        if(parseInt(that.selPais)>=1){
          // Validar que el país tenga la configuración necesaria
          if(that.selPaisAltaProveedor == 0 || that.selPaisCambioCuenta == 0){
            that.loadingVisible = false;
            var mensajeError = 'El país seleccionado no cuenta con configuración completa. Falta: ';
            var problemas = [];
            if(that.selPaisAltaProveedor == 0){
              problemas.push('documentación para alta de proveedor');
            }
            if(that.selPaisCambioCuenta == 0){
              problemas.push('documentación para cuenta bancaria');
            }
            mensajeError += problemas.join(' y ') + '. Favor de contactar al área de TI.';
            notify(mensajeError, 'error', 10000);
            return;
          }
          var require = (parseInt(that.selPais)==153)?false:true;
          var Subcontrato = (that.selSubcontratos==true)?1:0;
          if(that.selProyecto>=1){
            if(that.selRazonSocial || require){
              if(that.selNombreComercial){
                if(that.selDiasPlazo>=0){
                  if(that.selNombre){
                    if(that.selApellidoP){
                      if(that.selApellidoM){
                        if(that.selPuesto){
                          if(that.selCorreoContacto && isMail(that.selCorreoContacto)){
                            if(that.selTelefono){
                              if(that.selComentarios){//that.USERSIGA
                                if(that.USERSIGA){//that.USERSIGA
                                  //Id_ProveedoresSolicitudNuevoProv, Id_ProveedoresTipoEmpresa, Id_Pais, RazonSocial, NombreComercial, NombreContacto, ApellidoPaterno, ApellidoMaterno, Puesto, CorreoContacto, Celular, CometariosInvitacion, UserName, RFC_TaxID
                                  that.updInvitacionEnviarNuevo(that.NuevoExistente, that.MoralFisica, that.selPais, that.selRazonSocial, that.selNombreComercial, that.selNombre, that.selApellidoP, that.selApellidoM, that.selPuesto, that.selCorreoContacto, that.selTelefono, that.selComentarios, that.USERSIGA, that.selProyecto, Subcontrato, that.selDiasPlazo);
                                }else{
                                  that.loadingVisible = false;
                                  notify('Existe un problema con tu sesión favor de cerrar sesión y volverlo a intentar.', 'error');
                                }
                              }else{
                                that.loadingVisible = false;
                                notify('Favor de introducir el comentario.', 'error');
                              }
                            }else{
                              that.loadingVisible = false;
                              notify('Favor de introducir el teléfono.', 'error');
                            }
                          }else{
                            that.loadingVisible = false;
                            notify('Favor de introducir un correo electronico valido.', 'error');
                          }
                        }else{
                          that.loadingVisible = false;
                          notify('Favor de introducir el puesto.', 'error');
                        }
                      }else{
                        that.loadingVisible = false;
                        notify('Favor de introducir el apellido materno.', 'error');
                      }
                    }else{
                      that.loadingVisible = false;
                      notify('Favor de introducir el apellido paterno.', 'error');
                    }
                  }else{
                    that.loadingVisible = false;
                    notify('Favor de introducir el nombre.', 'error');
                  }
                }else{
                  that.loadingVisible = false;
                  notify('Favor de introducir los días de plazo.', 'error');
                }
              }else{
                that.loadingVisible = false;
                notify('Favor de introducir el nombre comercial.', 'error');
              }
            }else{
              that.loadingVisible = false;
              notify('Favor de introducir la razón social.', 'error');
            }
          }else{
            that.loadingVisible = false;
            notify('Favor de seleccionar el proyecto principal del proveedor.', 'error');
          }
        }else{
          that.loadingVisible = false;
          notify('Favor de seleccionar el pais.', 'error');
        }
      }else{
        if(that.selProveedor>=1){
          if(that.selNombre){
            if(that.selApellidoP){
              if(that.selApellidoM){
                if(that.selCorreoContacto){
                  if(that.selTelefono){
                    if(that.selComentarios){//that.USERSIGA
                      if(that.USERSIGA){//that.USERSIGA
                        that.updInvitacionEnviar(that.selProveedor, that.selCorreoContacto, that.selNombre, that.selApellidoP, that.selApellidoM, that.selTelefono, that.selComentarios, that.USERSIGA);
                      }else{
                        that.loadingVisible = false;
                        notify('Existe un problema con tu sesión favor de cerrar sesión y volverlo a intentar.', 'error');
                      }
                    }else{
                      that.loadingVisible = false;
                      notify('Favor de introducir el comentario.', 'error');
                    }
                  }else{
                    that.loadingVisible = false;
                    notify('Favor de introducir el teléfono.', 'error');
                  }
                }else{
                  that.loadingVisible = false;
                  notify('Favor de introducir el correo de contacto.', 'error');
                }
              }else{
                that.loadingVisible = false;
                notify('Favor de introducir el apellido materno.', 'error');
              }
            }else{
              that.loadingVisible = false;
              notify('Favor de introducir el apellido paterno.', 'error');
            }
          }else{
            that.loadingVisible = false;
            notify('Favor de introducir el nombre.', 'error');
          }
        }else{
          that.loadingVisible = false;
          notify('Favor de seleccionar el proveedor.', 'error');
        }
      }
    },
    //!PETICIONES A DB
    getInvitacionesProveedores:function(Id_EstatusWorkflow, mail, SoloMisInvitaciones, eliminado=null){
      var that = this;
      that.loadingVisible = true;
      apiClient.post('/api/Proveedores/InvitacionesProveedores', { Id_EstatusWorkflow: Id_EstatusWorkflow, Correo: mail, SoloMisInvitaciones: SoloMisInvitaciones, FormatoXML: false })
      .then(function (response) {
        console.log(response);
        that.JSONtbInvitaciones = response.data || [];
        if(eliminado) notify(eliminado, 'success');
        that.loadingVisible = false;
      })
      .catch(function (error) {
        notify('Error al consultar las invitaciones', 'error');
        console.log('Error: ' + error);
        that.loadingVisible = false;
      });
      that.resetChange=1;
    },
    updInvitacionEnviar:function(Id_Proveedor, Correo, Nombre, ApellidoPaterno, ApellidoMaterno, Telefono, Comentarios, Id_Usuario_Registro){
      var that = this;
      that.loadingVisible = true;
      apiClient.put('/api/Proveedores/updInvitacionEnviar', { Id_Proveedor: Id_Proveedor, Correo: Correo, Nombre: Nombre, ApellidoPaterno: ApellidoPaterno, ApellidoMaterno: ApellidoMaterno, Telefono: Telefono, Comentarios: Comentarios, Id_Usuario_Registro: Id_Usuario_Registro, FormatoXML: false }, { withLenguaje: true })
      .then(function (response) {
        console.log(response);
        if(response.data[0].Estatus=="Error"){
          notify(response.data[0].Mensaje,'error')
          that.loadingVisible = false;
        }else{
          // El SP updInvitacionEnviar ya envía el correo (BD/Power Automate). No se llama a SMTP.
          that.$refs['modal-1'].hide();
          that.getInvitacionesProveedores(that.selEstatus, that.USER, BooleanToInt(that.selVer));
          that.loadingVisible = false;
          notify(response.data[0].Mensaje, 'success');
        }

        //that.$refs['modal-1'].hide();
        //that.loadingVisible = false;
      })
      .catch(function (error) {
        notify('Error al guardar', 'error');
        console.log('Error: ' + error);
        that.loadingVisible = false;
      });
    },
    updInvitacionEnviarNuevo:function(Id_ProveedoresSolicitudNuevoProv, Id_ProveedoresTipoEmpresa, Id_Pais, RazonSocial, NombreComercial, NombreContacto, ApellidoPaterno, ApellidoMaterno, Puesto, CorreoContacto, Celular, CometariosInvitacion, UserName, Id_Proyecto, Subcontrato, DiasPlazo){
      var that = this;
      apiClient.put('/api/Proveedores/updInvitacionNuevoProveedorEnviar', { Id_ProveedoresSolicitudNuevoProv: Id_ProveedoresSolicitudNuevoProv, Id_ProveedoresTipoEmpresa: Id_ProveedoresTipoEmpresa, Id_Pais: Id_Pais, RazonSocial: RazonSocial, NombreComercial: NombreComercial, NombreContacto: NombreContacto, ApellidoPaterno: ApellidoPaterno, ApellidoMaterno: ApellidoMaterno, Puesto: Puesto, CorreoContacto: CorreoContacto, Celular: Celular, CometariosInvitacion: CometariosInvitacion, Id_Usuario: UserName, RFC_TaxID: '', Id_Proyecto: Id_Proyecto, Subcontratos: Subcontrato, DiasPlazo: DiasPlazo, FormatoXML: false }, { withLenguaje: true })
      .then(function (response) {
        console.log(response);
        if(response.data[0].Estatus.toLowerCase()=="error"){
          notify(response.data[0].Mensaje,'error')
          that.loadingVisible = false;
        }else{
          if(response.data[0].Token){
            // El SP updInvitacionNuevoProveedorEnviar ya envía el correo (BD/Power Automate). No se llama a SMTP.
            that.$refs['modal-1'].hide();
            that.getInvitacionesProveedores(that.selEstatus, that.USER, BooleanToInt(that.selVer));
            that.loadingVisible = false;
            notify(response.data[0].Mensaje, 'success');
          }else{
            that.loadingVisible = false;
            notify('Se esperaba token el cual no fue entregado, contacte al administrador.', 'error');
          }
        }
        ///that.loadingVisible = false;
      })
      .catch(function (error) {
        notify('Error al guardar', 'error');
        console.log('Error: ' + error);
        that.loadingVisible = false;
      });
    },
    getCancelar:function(Id_ProveedorUsuarioInvitacion, TipoInvitacion){
      var that = this;
      that.loadingVisible = true;
      apiClient.delete('/api/Proveedores/delInvitacion', { data: { Id_ProveedorUsuarioInvitacion: Id_ProveedorUsuarioInvitacion, FormatoXML: false, TipoInvitacion: TipoInvitacion }, withLenguaje: true })
      .then(function (response) {
        console.log(response);
        that.loadingVisible = false;
        that.getInvitacionesProveedores(that.selEstatus, that.USER, BooleanToInt(that.selVer), response.data[0].Mensaje);
      })
      .catch(function (error) {
        notify('Error al consultar las invitaciones', 'error');
        console.log('Error: ' + error);
        that.loadingVisible = false;
      });
    },
    modoDebug(){
        alert('Deveolp mode!');
    }
  }
}
</script>
<style scoped>
a{
  color: #313538 !important;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col, .col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm, .col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md, .col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg, .col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl, .col-xl-auto{
  display: inline-block;
}
.span-label{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}
.dx-datagrid-headers{
  font-weight: bold;
}
.selector_action{
  height: 24px;
  padding: 0px 0px;
}
.DxDataGrid-txtbold{
  text-decoration: underline;
  color: rgb(60, 142, 190, 0.9) !important;
  font-weight: 700;
  cursor: pointer;
}
.btnSimple{
  background: rgb(60, 142, 190, 0.9) !important;
}
.box{
  box-shadow:none;
}
.checkboxTextStile{
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: lighter;
  line-height: 1.5;
  color: #212529;
}
</style>
